// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"products_wrapper__JOjEN"};